// core/i18n/config.ts - Configuración de idiomas disponibles en Westeer

export interface Language {
  code: string;
  name: string;
  flag: string;
  nativeName: string;
}

export const LANGUAGES: Language[] = [
  {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸',
    nativeName: 'Español',
  },
  {
    code: 'en',
    name: 'English',
    flag: '🇬🇧',
    nativeName: 'English',
  },
  {
    code: 'pt',
    name: 'Português',
    flag: '🇵🇹',
    nativeName: 'Português',
  },
  {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    nativeName: 'Français',
  },
];

// 🇪🇸 Español es el idioma por defecto de Westeer
export const DEFAULT_LANGUAGE = 'es';

// 🇬🇧 Inglés como fallback si el idioma solicitado no existe
export const FALLBACK_LANGUAGE = 'en';

// Mapeo de códigos de región a idiomas soportados
export const REGION_TO_LANGUAGE: Record<string, string> = {
  // Español
  ES: 'es', // España
  AR: 'es', // Argentina
  MX: 'es', // México
  CO: 'es', // Colombia
  CL: 'es', // Chile
  PE: 'es', // Perú
  VE: 'es', // Venezuela
  EC: 'es', // Ecuador
  UY: 'es', // Uruguay

  // Portugués
  PT: 'pt', // Portugal
  BR: 'pt', // Brasil

  // Inglés
  US: 'en', // Estados Unidos
  GB: 'en', // Reino Unido
  CA: 'en', // Canadá
  AU: 'en', // Australia

  // Francés
  FR: 'fr', // Francia
  BE: 'fr', // Bélgica
};
